import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const getMemberships = catchAsync(async (LocationId) => {
  const { data } = await axiosInstance.get(`salon/${LocationId}/memberships`)
  return data;
});
export const getGiftCard = catchAsync(async (locationId) => {
  const { data } = await axiosInstance.get(`salon/${locationId}/gift-cards`);
  return data;
});
export const showSale = catchAsync(async (LocationId,SaleId) => {
  const { data } = await axiosInstance.get(`salon/${LocationId}/sales/${SaleId}`);
  return data;
});
export const addGiftCard = catchAsync(async (body) => {
  const  data  = await axiosInstance.post("salon/gift-cards", body);
  return data;
});
export const getSale = catchAsync(async (locationId,params) => {
  const { data } = await axiosInstance.get(
    `salon/${locationId}/sales`, {
    params,
  }
  );
  return data;
});

// export const addSale = catchAsync(async (body) => {
//   const { data } = await axiosInstance.post(
//     `/salon/${body?.location_id}/sales`,
//     body
//   );
//   return data;
// });
export const addSale = catchAsync(async (body) => {
  const data = await axiosInstance.post(
    `/salon/${body?.location_id}/sales`,
    body
  );
  return data;
});

// export const getSaleList = catchAsync(async () => {
//   const { data } = await axiosInstance.get("salon/sales");
//   return data;
// });
export const getSalesReports = catchAsync(async (locationId, params) => {
  let url = `salon/${locationId}/sales-reports`;
  const { data } = await axiosInstance.get(url, {
    params,
  });
  return data;
});
export const getSaleList = catchAsync(async (locationId, params) => {
  let url = `salon/${locationId}/sales`;

  // let query = "?";
  // if (body?.start_date) {
  //   query += "start_date=" + body?.start_date;
  // }
  // if (body?.end_date) {
  //   query += "&end_date=" + body?.end_date;
  // }
  // if (body?.search) {
  //   query += `&search=${body?.search}`;
  // }
  // if (body?.current_page) {
  //   query += `&current_page=${body?.current_page}`;
  // }
  // if (body?.status) {
  //   query += `&status=${body?.status}`;
  // }

  // return axiosInstance.get(`salon/sales${query}`);
  const { data } = await axiosInstance.get(url, { params });
  return data;
});
